import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const MainContainer = styled(Box)`
    display: flex;
    min-height: 100%;
    flex-direction: column;
    justify-content: space-between;
`
export const SocialIconsContainer = styled(Box)`
    display: flex; 
    width: 120px; 
    justify-content: space-between; 
    padding-top: 16px;
`
